import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TableState {
  searchKey: string;
  isLoading: boolean;
}

const initialState: TableState = {
  searchKey: "",
  isLoading: false,
};

export const generateTableSlice = (tableName: string) => {
  const slice = createSlice({
    name: tableName + "Table",
    initialState,
    reducers: {
      setSearchKey: (state, action: PayloadAction<string>) => {
        state.searchKey = action.payload;
      },

      setIsLoading: (state, action: PayloadAction<boolean>) => {
        state.isLoading = action.payload;
      },
    },
  });

  return slice;
};
